import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import addProductHelpers from "../addProductHelpers";
import { productWithGroup } from "../../global/storefront/queries";

const cache = {};

export default function fetchProduct(id) {
  if (id in cache) {
    return cache[id];
  }

  cache[id] = storefront
    .request({
      query: productWithGroup,
      variables: {
        id,
      },
    })
    .then(({ data }) => {
      const output = unwrapNodes(data.product);
      addProductHelpers(output);

      return output;
    });

  return cache[id];
}
